import EventImage from '../../../common/images/community/event.jpg';
import LiveImage from '../../../common/images/community/live.jpg';
import UpdatesImage from '../../../common/images/community/updates.jpg';
import { CommunityCell } from '../../../components/community/CommunityCell.component';
import styles from './CommunityDashboardPage.module.css';

const CommunityCellRows = () => {
  return (
    <div className={styles.communityCellRows}>
      <div className={styles.communityCellRow}>
        <CommunityCell
          title="EVENTS"
          image={EventImage}
          href="/platform/events"
        />
        <CommunityCell
          title="MOGUL LIVE"
          image={LiveImage}
          href="/platform/live"
          isOffset
        />
      </div>
      <div className={styles.communityCellRow}>
        <CommunityCell
          title="MOGUL UPDATES"
          image={UpdatesImage}
          href="/platform/updates"
        />
      </div>
    </div>
  );
};

export const CommunityDashboardPage = () => {
  return (
    <div className={styles.communityContainer}>
      <h1 className={styles.commmunityHeading}>Community</h1>
      <CommunityCellRows />
    </div>
  );
};
